<div
	[class.c-message--blue]="color === 'blue'"
	[class.c-message--green]="color === 'green'"
	[class.c-message--orange]="color === 'orange'"
	[class.c-message--red]="color === 'red'"
	[class.c-message--sm]="sm"
	class="c-message"
>
	@if (icon) {
		<div class="c-message__icon">
			<tvcore-icon [name]="icon"></tvcore-icon>
		</div>
	}

	<div class="c-message__content flex--1">
		<ng-content></ng-content>
	</div>
</div>
